import {Pipe, PipeTransform} from '@angular/core';
import {ActivityDate} from "../../services/DateService";

/**
 * Generated class for the EpochToDatePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'epochToDate',
})
export class EpochToDatePipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: number, ...args) {
    const d = new ActivityDate();
    d.dateStamp = value;
    return d.asDate();
  }
}



// WEBPACK FOOTER //
// ./src/pipes/epoch-to-date/epoch-to-date.ts